/**
 * 导航分类数据模型
 * 按照用户群体和功能进行分类设计
 */

export const defaultCategories = [
  // ========== 程序员核心分类 ==========
  {
    id: 'dev-tools',
    name: '开发工具',
    icon: 'code',
    color: '#3B82F6',
    description: 'IDE、编辑器、终端工具等',
    priority: 1,
    tags: ['程序员', '开发']
  },
  {
    id: 'dev-docs',
    name: '技术文档',
    icon: 'book',
    color: '#8B5CF6',
    description: '官方文档、API参考、教程',
    priority: 2,
    tags: ['程序员', '学习']
  },
  {
    id: 'code-hosting',
    name: '代码托管',
    icon: 'git-branch',
    color: '#10B981',
    description: 'GitHub、GitLab、Gitee等',
    priority: 3,
    tags: ['程序员', '协作']
  },
  {
    id: 'ai-tools',
    name: 'AI 工具',
    icon: 'brain',
    color: '#F59E0B',
    description: 'ChatGPT、Claude、Copilot等AI助手',
    priority: 4,
    tags: ['程序员', 'AI', '效率']
  },
  {
    id: 'cloud-services',
    name: '云服务',
    icon: 'cloud',
    color: '#06B6D4',
    description: 'AWS、阿里云、腾讯云等',
    priority: 5,
    tags: ['程序员', '运维']
  },
  {
    id: 'dev-community',
    name: '技术社区',
    icon: 'users',
    color: '#EC4899',
    description: 'Stack Overflow、掘金、V2EX等',
    priority: 6,
    tags: ['程序员', '社区']
  },

  // ========== 设计相关 ==========
  {
    id: 'design-tools',
    name: '设计工具',
    icon: 'palette',
    color: '#F97316',
    description: 'Figma、Sketch、PS等设计软件',
    priority: 10,
    tags: ['设计', '创意']
  },
  {
    id: 'design-resources',
    name: '设计资源',
    icon: 'image',
    color: '#EF4444',
    description: '图标、素材、配色方案',
    priority: 11,
    tags: ['设计', '资源']
  },

  // ========== 效率工具 ==========
  {
    id: 'productivity',
    name: '效率工具',
    icon: 'zap',
    color: '#84CC16',
    description: '笔记、日程、项目管理',
    priority: 20,
    tags: ['效率', '通用']
  },
  {
    id: 'online-tools',
    name: '在线工具',
    icon: 'tool',
    color: '#64748B',
    description: '格式转换、图片处理、文档工具',
    priority: 21,
    tags: ['工具', '通用']
  },

  // ========== 学习教育 ==========
  {
    id: 'learning',
    name: '学习平台',
    icon: 'graduation-cap',
    color: '#7C3AED',
    description: '在线课程、编程学习',
    priority: 30,
    tags: ['学习', '教育']
  },
  {
    id: 'books',
    name: '电子书籍',
    icon: 'book-open',
    color: '#0EA5E9',
    description: '技术书籍、电子书资源',
    priority: 31,
    tags: ['学习', '阅读']
  },

  // ========== 资讯媒体 ==========
  {
    id: 'tech-news',
    name: '科技资讯',
    icon: 'newspaper',
    color: '#6366F1',
    description: '科技新闻、行业动态',
    priority: 40,
    tags: ['资讯', '科技']
  },
  {
    id: 'social-media',
    name: '社交媒体',
    icon: 'share-2',
    color: '#1DA1F2',
    description: '微博、Twitter、知乎等',
    priority: 41,
    tags: ['社交', '通用']
  },

  // ========== 生活娱乐 ==========
  {
    id: 'entertainment',
    name: '影音娱乐',
    icon: 'play-circle',
    color: '#DC2626',
    description: '视频、音乐、直播',
    priority: 50,
    tags: ['娱乐', '通用']
  },
  {
    id: 'shopping',
    name: '网上购物',
    icon: 'shopping-cart',
    color: '#EA580C',
    description: '电商平台、比价工具',
    priority: 51,
    tags: ['购物', '通用']
  },
  {
    id: 'finance',
    name: '金融理财',
    icon: 'dollar-sign',
    color: '#16A34A',
    description: '银行、证券、数字货币',
    priority: 52,
    tags: ['金融', '通用']
  },

  // ========== 个人收藏 ==========
  {
    id: 'favorites',
    name: '我的收藏',
    icon: 'star',
    color: '#FBBF24',
    description: '个人收藏的网站',
    priority: 100,
    tags: ['个人', '收藏'],
    isSystem: true
  },
  {
    id: 'recent',
    name: '最近访问',
    icon: 'clock',
    color: '#94A3B8',
    description: '最近访问的网站',
    priority: 101,
    tags: ['个人', '历史'],
    isSystem: true
  }
]

export const categoryGroups = [
  {
    id: 'developer',
    name: '开发者专区',
    categories: ['dev-tools', 'dev-docs', 'code-hosting', 'ai-tools', 'cloud-services', 'dev-community']
  },
  {
    id: 'design',
    name: '设计创意',
    categories: ['design-tools', 'design-resources']
  },
  {
    id: 'productivity',
    name: '效率工具',
    categories: ['productivity', 'online-tools']
  },
  {
    id: 'learning',
    name: '学习成长',
    categories: ['learning', 'books']
  },
  {
    id: 'media',
    name: '资讯媒体',
    categories: ['tech-news', 'social-media']
  },
  {
    id: 'life',
    name: '生活娱乐',
    categories: ['entertainment', 'shopping', 'finance']
  },
  {
    id: 'personal',
    name: '个人空间',
    categories: ['favorites', 'recent']
  }
]
